import { CriteriaNotificationsFilter } from "../interfaces/criteria-notifications-filter";
import { CriteriaAbs } from "./criteria-abs";
import { Notification } from './notification';

export class CriteriaLevelRead extends CriteriaAbs implements CriteriaNotificationsFilter {
  getNotificationsWithFilter(): Promise<Notification[]> {
    return new Promise<Notification[]>((resolve, reject) => {
      this.notificationService.getNotificationsLevelReadBeforeDate().subscribe((result) => {
        resolve(result);
      });
    });
  }
}
